import { render, staticRenderFns } from "./SongEmailView.vue?vue&type=template&id=8da8d74e"
import script from "./SongEmailView.vue?vue&type=script&lang=js"
export * from "./SongEmailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports